import React from 'react';
import Slider from '../../vendor/react-slick/slider';
import LazyloadImage from "../LazyloadImage";
import PrevArrow from '../CarouselArrows/prev-arrow';
import NextArrow from '../CarouselArrows/next-arrow';
import { isMobile } from "../../utilities/javascript/browser";
import styles from './styles.css';

export default class LatestCollectionCarousel extends React.Component {
  constructor(props) {
    super(props);
    const isMobile = props.isMobile;
    this.state = {
      arrows: !isMobile,
      slidesToShow: isMobile ? 3 : 5,
      cardStyle: isMobile ? { width: 105 } : { width: 238 },
      custom_img_id: isMobile ? 'mobile_img_id' : 'desktop_img_id'
    }
  }

  static defaultProps = {
    designerId: '',
    designerName: '',
    designerUrl: '',
    collectionCardsInfos: ''
  };

  onWindowResize() {
    this.setState({
      arrows: !isMobile(),
      slidesToShow: isMobile() ? 3 : 5,
      cardStyle: isMobile() ? { width: 105 } : { width: 238 },
      custom_img_id: isMobile() ? 'mobile_img_id' : 'desktop_img_id'
    })
  }

  componentDidMount() {
    this.onWindowResize();
    if (window && window.addEventListener) {
      window.addEventListener('resize', this.onWindowResize.bind(this))
    }
  }

  render() {
    const { designerId, designerName, designerUrl, collectionCardsInfos } = this.props;
    const { arrows, slidesToShow, cardStyle, custom_img_id } = this.state;
    const settings = {
      arrows: arrows,
      infinite: false,
      slidesToShow: slidesToShow,
      swipeToSlide: true,
      variableWidth: true,
      className: `${styles['slick-slider']}`,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />
    };

    let galleryCard = function (gallery, index) {
      let linkingSlug = `/fashion/${gallery.linking_slug}`;
      let headlineClass = gallery.text_class ? styles[gallery.text_class] : "";

      return (
        <a id={`gallery-link-${index}`}
          class="collection-link"
          target="_blank"
          tabIndex={-1}
          href={linkingSlug}
          data-designer-id={designerId}
          data-designer-name={designerName}
          data-designer-url={designerUrl}>
          <LazyloadImage
            containerClassName='latest-collection-image-container'
            image={gallery[custom_img_id]}
            alt={gallery.img_alt}
            desktopWidth={224}
            desktopHeight={328}
            mobileWidth={105}
            mobileHeight={156}
          />
          <div className={`${styles['panel-heading']} ${headlineClass}`} style={{ '-webkit-box-orient': 'vertical' }}>
            <span>{gallery.headline}</span>
          </div>
        </a>
      )
    }

    return (
      <div class={styles['latest-collection-container']}>
        <div className={styles['section-title']}>
          <h3>Latest Collections</h3>
        </div>
        <Slider {...settings}>
          {
            collectionCardsInfos.map(function (gallery, index) {
              return <div style={cardStyle} className={styles['collection-card']}>
                {
                  galleryCard(gallery, index)
                }
              </div>
            })
          }
        </Slider>
      </div>
    )
  }
}
